import React from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import _ from 'lodash';
import validator from 'validator';
import s from './Quantity.scss';
import { classes } from './Quantity.st.css';
import settingsParams from '../../../settingsParams';
import { useControllerProps } from '../../ControllerContext';
import { useState } from '../../stores';
import { Counter, CounterSize } from 'wix-ui-tpa';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { SPECS } from '../../../../../consts';

export enum QuantityDataHook {
  quantitySelector = 'QuantityDataHook.quantitySelector',
}

const Quantity = () => {
  const {
    state: { checkout },
    dispatch,
  } = useState();
  const settings = useSettings();
  const { experiments } = useExperiments();
  const {
    purchase_options_validation,
    show_errors,
    setPurchaseOptionsValidation,
  } = useControllerProps().giftCardCheckoutStore;

  const shouldUseInputFieldsCornerRadius = experiments.enabled(
    SPECS.RecipientInputFieldsCornerRadius,
  );

  const shouldUseQuantityAriaLabels = experiments.enabled(
    SPECS.KeysForQuantityAriaLabels,
  );

  return (
    <fieldset data-hook={QuantityDataHook.quantitySelector}>
      <legend className={s.label}>
        {settings.get(settingsParams.quantityLabel)}
      </legend>
      <Counter
        data-hook="rise-gift-card-quantity-counter"
        className={
          shouldUseInputFieldsCornerRadius
            ? classes.counter
            : classes.counterOld
        }
        onChange={(value) => {
          dispatch({
            type: 'setPurchaseOptions',
            payload: {
              quantity: Number(value),
            },
          });
          setPurchaseOptionsValidation(
            'quantity',
            validator.isInt(value, { min: 1, max: 10 }),
          );
        }}
        min={1}
        max={10}
        errorMessage={settings.get(settingsParams.quantityErrorMessage)}
        error={show_errors && !_.get(purchase_options_validation, 'quantity')}
        inputAriaLabel={settings.get(settingsParams.srQuantityTotalQuantity)}
        incrementAriaLabel={
          shouldUseQuantityAriaLabels
            ? settings.get(settingsParams.increaseQuantityAriaLabel)
            : undefined
        }
        decrementAriaLabel={
          shouldUseQuantityAriaLabels
            ? settings.get(settingsParams.decreaseQuantityAriaLabel)
            : undefined
        }
        size={CounterSize.medium}
        value={checkout.purchaseOptions.quantity}
      />
    </fieldset>
  );
};

export default Quantity;
